import axios from "axios";

export const createResumePDF = async(props) => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/pdf/${props.apiName}`;

    const values = props.values;

    var result = [];

    await axios.post(url, values)
    .then( response => {
        const data = response.data;
        result = {...data};
        if (data.exito === 1) {
            console.log("createResumePDF sucess...");
        }
    })

    return result;
};
